<template>
  <div class="card position-relative">
    <LoadingOverlay :show="loading" />
    <div class="card-body">
      <div class="mb-3">
        <label for="link" class="form-label">Currency</label>
        <select
          id="link"
          class="form-select"
          placeholder="Please select"
          v-model="form.link"
        >
          <option
            v-for="item in currencyList"
            :value="item.value"
            :key="item.value"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="mb-3">
        <label for="address" class="form-label">Address</label>
        <input
          type="text"
          class="form-control"
          id="address"
          placeholder="Wallet address"
          v-model="form.address"
        />
      </div>
      <div class="mb-3">
        <label for="charges" class="form-label">Qr code of wallet</label>
        <ImageUploader v-model="form.screenshotFile" />
      </div>
      <button class="btn btn-primary" type="button" @click="submit">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ImageUploader from "@/components/ImageUploader.vue";
import { message } from "@/utils/message";
import { addWallet, uploadImg } from "@/apis/wallet";
export default {
  data() {
    return {
      loading: false,
      currencyList: [
        {
          name: "ERC20",
          value: "ERC20",
        },
        {
          name: "TRC20",
          value: "TRC20",
        },
      ],
      form: {
        link: "",
        address: "",
        screenshotFile: null,
      },
    };
  },
  components: {
    LoadingOverlay,
    ImageUploader,
  },
  methods: {
    async submit() {
      console.log(this.form);
      if (!this.form.link || !this.form.address || !this.form.screenshotFile) {
        message.error("Please fill in all fields");
        return;
      }
      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("file", this.form.screenshotFile);
        const fileRes = await uploadImg(formData);
        console.log(fileRes);
        if (fileRes.code === 0 && fileRes.save_path) {
          const params = {
            type: "USDT",
            link: this.form.link,
            addr: this.form.address,
            qr: fileRes.save_path,
          };
          const res = await addWallet(params);
          this.loading = false;
          console.log(res);
          if (res.code === 0) {
            message.success("Add wallet address successfully");
            this.$router.go(-1);
          }
        } else {
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
